import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { MapView } from "../components/MapView";
import { MILAN_CENTER, plural } from "../lib/constants";
import { Navigation, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function MapPage() {
  const [events, setEvents] = useState([]);
  const [userPos, setUserPos] = useState(null);
  const [center, setCenter] = useState(MILAN_CENTER);
  const [nearbyMode, setNearbyMode] = useState(false);
  const [locating, setLocating] = useState(false);

  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)).catch(() => {}); }, []);

  const findNearby = () => {
    if (!navigator.geolocation) { toast.error("Geolocalizzazione non supportata"); return; }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        setUserPos([latitude, longitude]);
        setCenter([latitude, longitude]);
        try {
          const { data } = await api.get("/events/nearby", { params: { lat: latitude, lng: longitude, radius: 5 } });
          setEvents(data);
          setNearbyMode(true);
          toast.success(`${plural(data.length, "evento", "eventi")} vicino a te`);
        } catch { toast.error("Errore nel recupero eventi"); }
        finally { setLocating(false); }
      },
      () => { toast.error("Permesso di localizzazione negato"); setLocating(false); },
      { timeout: 10000 }
    );
  };

  const showAll = () => {
    api.get("/events").then((r) => { setEvents(r.data); setNearbyMode(false); setCenter(MILAN_CENTER); }).catch(() => {});
  };

  return (
    <div className="pt-24 max-w-7xl mx-auto px-5 pb-16">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
        <div>
          <div className="overline text-wyd-accent mb-2">Mappa</div>
          <h1 className="font-display font-black text-4xl">La notte, sulla mappa</h1>
          <p className="text-wyd-muted mt-2">{plural(events.length, "evento", "eventi")} {nearbyMode ? "vicino a te" : "a Milano"}</p>
        </div>
        <div className="flex gap-3">
          {nearbyMode && (
            <button data-testid="show-all-btn" onClick={showAll} className="px-5 py-3 rounded-full bg-transparent border border-wyd-accent text-wyd-accent hover:bg-wyd-accent/10 transition-colors duration-200 text-sm">
              Mostra tutti
            </button>
          )}
          <button data-testid="nearby-btn" onClick={findNearby} disabled={locating}
            className="px-6 py-3 rounded-full bg-wyd-accent text-wyd-bg font-semibold flex items-center gap-2 hover:glow-magenta transition-shadow duration-300 disabled:opacity-60">
            {locating ? <Loader2 size={18} className="animate-spin" /> : <Navigation size={18} />} Vicino a me
          </button>
        </div>
      </div>
      <MapView events={events} center={center} userPos={userPos} height="72vh" />
    </div>
  );
}
